
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexfb4MtJUQ5WQC1_JE9IETJTu5vU4j9plXJeu28IWrkgQMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/index.vue?macro=true";
import { default as loginvhhbxdc3blZtbAkfCqFbzHTClJyrIzguO0QuGv8hU9MMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/login.vue?macro=true";
import { default as createKbj6SecaKenP1apdr80bSCyGvWuBCIo6w4fVG4JgljwMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/create.vue?macro=true";
import { default as forgote7JjvjJbmpj4oEs3DLqUKxTH8dihkijScXQrRzeitowMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/forgot.vue?macro=true";
import { default as reportseigz9mVH7rD1wrwZbFHgouSBhRdJXt2bXBg1orm9FJUMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/reports.vue?macro=true";
import { default as sign_45upSP8Cjoq29t_45FzBEp2PiEodZ4CoUgaqHM7REqYCBrYjkMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/sign-up.vue?macro=true";
import { default as insightsqa2lKGRZy4pUU2Kr0HokOsAl8nnkp2N1hJWteMPIBicMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/insights.vue?macro=true";
import { default as newU1sEoMx7aKKcSYAi1e9oGfyDgan4sFuI4fdtXQzPAtkMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/users/new.vue?macro=true";
import { default as newXY_45PUrrne9JZQtelFF3fo2CegyhnSt_45xrnqESlk6RGAMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/makers/new.vue?macro=true";
import { default as newtlCq82xeIC6moo8iDI_1TWTnRZKM_mLYe0keaMvk96AMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/orders/new.vue?macro=true";
import { default as _91id_93lQL4DoB23V7h_451_qfP1pp7fNFmucFBNHWUWS9D8pnJsMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/users/[id].vue?macro=true";
import { default as newhiVyPFwVY6ZvAzUNv7oqz6MP7jop4SLIsaO9Pn9fOs0Meta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/verify/new.vue?macro=true";
import { default as _91id_935syMxcIvg3z0ATMOyCU_45Yk0z8LrIxkHaBNjeUlKKtWgMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/makers/[id].vue?macro=true";
import { default as newPIu27CtYWmZQtdzjahtD9tigLLqhVCnRGjhPFgL0kp8Meta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/rewards/new.vue?macro=true";
import { default as index9WKKUGcAcWf8hzQOVfln1o8t108TtLLEMgMKNupQZpAMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/users/index.vue?macro=true";
import { default as _91id_93fYmbgCkIyg0rykve0XEbP9C967carRCYanYVFNMJbV8Meta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/verify/[id].vue?macro=true";
import { default as integrationsHRM6cBMnd2WbVLDIcEOyaTRGIUvEEOEXTcGHKwXAUDMMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/integrations.vue?macro=true";
import { default as index7UhqvtbEaE93FooM3TRmiikjMq5N63IqxaInbWzHO3YMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/makers/index.vue?macro=true";
import { default as indexISSZYAGDIpYOKTrCI37MLkhJcHw6XhB14vlLJckYoAAMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/orders/index.vue?macro=true";
import { default as newk93isJ9KSd4JGvrMiDYDkFBuj5hdSsIJyNLfYmABuBsMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/packages/new.vue?macro=true";
import { default as newZY85Sf0_45o674kVAmhjeYPR_45PoKZdBVL9NRzXbk4FVBUMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/products/new.vue?macro=true";
import { default as indexctR5QBGeV3wPYjJU8SiQOVG_458k79Er7hUNWciaiCttsMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/queues/index.vue?macro=true";
import { default as _91id_93iQ8pJoGxgHrAOeCAiCNSFhph2Gjl4fzwcA7NH_45SZI_458Meta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/rewards/[id].vue?macro=true";
import { default as newqSCV26RKWxBYkcQkzaZN1trcqotXB1xccbke5ArXSQoMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/settings/new.vue?macro=true";
import { default as newotSZfAFfp18RgCVrqd6M7lAiDy0H_456L7FX1SedNaiWkMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/discounts/new.vue?macro=true";
import { default as _91id_93abfatW4PGFbStptv2G3fPPL_45YfUc4VQVvEwvwTEiOP8Meta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/packages/[id].vue?macro=true";
import { default as _91id_9371eUyN_45pqEy3iyciltQ1kLIhrvKxHnYlXYQsy1eTZtQMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/password/[id].vue?macro=true";
import { default as _91id_93S3t3Nif_2yQ5NFbN86qWf5LQ8tgO9Kc1_LEdx8bhaeoMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/products/[id].vue?macro=true";
import { default as indextXyEJzmo9j_t2vLi0_PKwCjYcKJ_MqcG3SxZRiwjwGcMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/rewards/index.vue?macro=true";
import { default as _91id_93drkJIb0hKDpCB2nVNsEACFNaWAFDjfFXQ2JAHHt7hN0Meta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/settings/[id].vue?macro=true";
import { default as _91id_93bEMeOP6oVtTKInBJdpoTSC731mLSmUutciNylGl_58wMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/customers/[id].vue?macro=true";
import { default as _91id_93LOTofA68CCQ5UhNmxSs50f0_4UGIfjQRflnQ2vM1LCcMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/discounts/[id].vue?macro=true";
import { default as download777o2Zab3hBdDj_k1RdUdbtjIgNl2yGA2lSQkN_45A6XMMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/files/download.vue?macro=true";
import { default as indexy5Txf8rs4toTZfYXSzGEVJbMasMuBpkH1ZOwRLnzsWoMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/packages/index.vue?macro=true";
import { default as indexYgX6e9NsFWgdxmaQjLHVt5CGEtw_456RjAEjPXnV4JrPEMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/products/index.vue?macro=true";
import { default as indexOcnBkQ89k1775vhHq4VCkHtUSPp718CsxSD4lyVWOSIMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/settings/index.vue?macro=true";
import { default as newUz1dxtVKqcsfdikotaOobgv3ojNeOgXxCBrARMxCLnoMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/cost-centre/new.vue?macro=true";
import { default as indexKNKeGKn8MlPzrgCojv_45z95DZLy01a26jyoNw6qI8B2UMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/customers/index.vue?macro=true";
import { default as indexKUO3BpHPVJUPSHv2v8JF3BNq6Mka5uoI6_LtDy5xGRUMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/discounts/index.vue?macro=true";
import { default as _91id_93kvfTo8OI2idTj64TzZGe04Q0U5qkdBYwqVC6ry7WhekMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/cost-centre/[id].vue?macro=true";
import { default as indexgMfIkRu_45sLbq9Kpk30h14_AX1YrN_45YGRQGk_kPB_ZTwMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/cost-centre/index.vue?macro=true";
import { default as indexPak0D2xvoIhkP8m3KwPCtdubfUuPlfGFeUDG2znvyToMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/orders/[id]/index.vue?macro=true";
import { default as newr8TDXLxbeR5_45nUueK9r_Khe_bpyY2TbkNS3cub7B0C8Meta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/organisations/new.vue?macro=true";
import { default as _91id_935fYq_fqF_452_45uidt1N_SYd6noGa_45JBLgV4YvJZGL8_9YMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/organisations/[id].vue?macro=true";
import { default as indexlIloeyrNL4DtOh52tw_jyvgEhMt6s2EIGX7WhwZZxvEMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/organisations/index.vue?macro=true";
import { default as newNwoo3QKfTFGtZrVKuWzioiCPEHltJLM8we34wbuZidgMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/maker-categories/new.vue?macro=true";
import { default as _91id_93FNXu838nzEVYYB5iMgwoVBnar7vFybriy27w4vVyZjIMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/maker-categories/[id].vue?macro=true";
import { default as indexr1tS9h_45PpMAFDfiJ3fKu5NmKzI1_45O_jRe9ON_45eB57U8Meta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/maker-categories/index.vue?macro=true";
import { default as newbkN0IJHmD_45eivHa2fk7KNhQAkLk4P3Eh_45HUq4vcfdqAMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/product-categories/new.vue?macro=true";
import { default as _91id_93TmIh_45tDtTB5nLP4qfOV2YZRHYtqd4t6u_45FRNylNsr2EMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/product-categories/[id].vue?macro=true";
import { default as indexTsu0nqFWV5WPFl6KjS4P9FSaGACi0TMiYJFN7ptiNaEMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/product-categories/index.vue?macro=true";
import { default as _91id_93FPWnKxp2Xt2OAJ70ScAg7rHx5oHomWHD3_45hRprQXj_454Meta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/settings/subConfigs/[id].vue?macro=true";
import { default as transaction_45historyZrz_45K5YEVm7qxjaN99J5eMnUM5P2pbOIvKVFQeyuLaAMeta } from "/codebuild/output/src1396430654/src/and-dine-hub/pages/orders/[id]/transaction-history.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/login.vue")
  },
  {
    name: "create",
    path: "/create",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/create.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/forgot.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/reports.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/sign-up.vue")
  },
  {
    name: "insights",
    path: "/insights",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/insights.vue")
  },
  {
    name: "users-new",
    path: "/users/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/users/new.vue")
  },
  {
    name: "makers-new",
    path: "/makers/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/makers/new.vue")
  },
  {
    name: "orders-new",
    path: "/orders/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/orders/new.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/users/[id].vue")
  },
  {
    name: "verify-new",
    path: "/verify/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/verify/new.vue")
  },
  {
    name: "makers-id",
    path: "/makers/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/makers/[id].vue")
  },
  {
    name: "rewards-new",
    path: "/rewards/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/rewards/new.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/users/index.vue")
  },
  {
    name: "verify-id",
    path: "/verify/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/verify/[id].vue")
  },
  {
    name: "integrations",
    path: "/integrations",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/integrations.vue")
  },
  {
    name: "makers",
    path: "/makers",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/makers/index.vue")
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/orders/index.vue")
  },
  {
    name: "packages-new",
    path: "/packages/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/packages/new.vue")
  },
  {
    name: "products-new",
    path: "/products/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/products/new.vue")
  },
  {
    name: "queues",
    path: "/queues",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/queues/index.vue")
  },
  {
    name: "rewards-id",
    path: "/rewards/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/rewards/[id].vue")
  },
  {
    name: "settings-new",
    path: "/settings/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/settings/new.vue")
  },
  {
    name: "discounts-new",
    path: "/discounts/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/discounts/new.vue")
  },
  {
    name: "packages-id",
    path: "/packages/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/packages/[id].vue")
  },
  {
    name: "password-id",
    path: "/password/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/password/[id].vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/products/[id].vue")
  },
  {
    name: "rewards",
    path: "/rewards",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/rewards/index.vue")
  },
  {
    name: "settings-id",
    path: "/settings/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/settings/[id].vue")
  },
  {
    name: "customers-id",
    path: "/customers/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/customers/[id].vue")
  },
  {
    name: "discounts-id",
    path: "/discounts/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/discounts/[id].vue")
  },
  {
    name: "files-download",
    path: "/files/download",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/files/download.vue")
  },
  {
    name: "packages",
    path: "/packages",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/packages/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/products/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/settings/index.vue")
  },
  {
    name: "cost-centre-new",
    path: "/cost-centre/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/cost-centre/new.vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/customers/index.vue")
  },
  {
    name: "discounts",
    path: "/discounts",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/discounts/index.vue")
  },
  {
    name: "cost-centre-id",
    path: "/cost-centre/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/cost-centre/[id].vue")
  },
  {
    name: "cost-centre",
    path: "/cost-centre",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/cost-centre/index.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/orders/[id]/index.vue")
  },
  {
    name: "organisations-new",
    path: "/organisations/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/organisations/new.vue")
  },
  {
    name: "organisations-id",
    path: "/organisations/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/organisations/[id].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/organisations/index.vue")
  },
  {
    name: "maker-categories-new",
    path: "/maker-categories/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/maker-categories/new.vue")
  },
  {
    name: "maker-categories-id",
    path: "/maker-categories/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/maker-categories/[id].vue")
  },
  {
    name: "maker-categories",
    path: "/maker-categories",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/maker-categories/index.vue")
  },
  {
    name: "product-categories-new",
    path: "/product-categories/new",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/product-categories/new.vue")
  },
  {
    name: "product-categories-id",
    path: "/product-categories/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/product-categories/[id].vue")
  },
  {
    name: "product-categories",
    path: "/product-categories",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/product-categories/index.vue")
  },
  {
    name: "settings-subConfigs-id",
    path: "/settings/subConfigs/:id()",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/settings/subConfigs/[id].vue")
  },
  {
    name: "orders-id-transaction-history",
    path: "/orders/:id()/transaction-history",
    component: () => import("/codebuild/output/src1396430654/src/and-dine-hub/pages/orders/[id]/transaction-history.vue")
  }
]